import 'whatwg-fetch';
import * as constants from '../constants/actions';
import * as endpoint from '../constants/endpoints';
import * as api from '../constants/api';

import {parseJSON,isOk} from '../utils/request';


/******************************
*******  Synchronous  *********
******************************/



/******************************
*******  Asynchronous  ********
******************************/

export function callLogin(email, password) {
	return dispatch => {
		let url = api.API_URL + endpoint.USERS_LOGIN;
		let data = {
			email: email,
			password: password
		}
		return fetch(url, {
		  method: 'post',
		  headers: api.HEADERS,
		  body: JSON.stringify(data)
		})
		.then(parseJSON)
		.then((resp) => {
	    if(isOk(resp.status)) {
	    	return Promise.resolve(resp.data);
	    } else {
	    	return Promise.reject(resp.data);
	    }
	  });
	}
}

export function callForgotPassword(email) {
	return dispatch => {
		let url = api.API_URL + endpoint.USERS_FORGOT_PASSWORD;
		let data = {
			email: email,
		}
		return fetch(url, {
		  method: 'post',
		  headers: api.HEADERS,
		  body: JSON.stringify(data),
		})
		.then(parseJSON)
		.then((resp) => {
	    if(isOk(resp.status)) {
	    	return Promise.resolve(resp.data);
	    } else {
	    	return Promise.reject(resp.data);
	    }
	  });
	}
}

// export function callResetPassword(resetData) {
// 	return dispatch => {
// 		let url = api.API_URL + endpoint.USERS_RESET_PASSWORD;
// 		return fetch(url, {
// 		  method: 'post',
// 		  headers: api.HEADERS,
// 		  body: JSON.stringify(resetData),
// 		})
// 		.then(parseJSON)
// 		.then((resp) => {
// 	    if(isOk(resp.status)) {
// 	    	return Promise.resolve(resp.data);
// 	    } else {
// 	    	return Promise.reject(resp.data);
// 	    }
// 	  });
// 	}
// }